import { render, staticRenderFns } from "./plan-section.vue?vue&type=template&id=16bd0c70&scoped=true&"
import script from "./plan-section.vue?vue&type=script&lang=js&"
export * from "./plan-section.vue?vue&type=script&lang=js&"
import style0 from "./plan-section.vue?vue&type=style&index=0&id=16bd0c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bd0c70",
  null
  
)

export default component.exports